import { render } from "./IndexView.vue?vue&type=template&id=3d38a7b4&ts=true"
import script from "./IndexView.vue?vue&type=script&lang=ts"
export * from "./IndexView.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src678506843/src/babyhead-viewer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__